import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {
	init() {

		function SectionWithStepsAction( container ) {

			var stepsContainer = container.querySelector('.content__grid');

			var controller = new ScrollMagic.Controller();

			new ScrollMagic.Scene({triggerElement: stepsContainer, triggerHook: 0.75 })
				// trigger animation by adding a css class
				.setClassToggle(stepsContainer, "backToPosition")
				// .addIndicators({name: "- SectionWithSteps "}) // add indicators (requires plugin)
				.addTo(controller)
				.offset(1);

		}

		var container = document.querySelectorAll('.sectionWithSteps');

		if( container.length > 0 ) {

			container.forEach( function( box, index ) {

				SectionWithStepsAction( box );

			});

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
